import I18n from 'I18n';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FriendlySenderName = ({
  channelName,
  isNamedUnknownVisitor,
  senderName,
  isLoading
}) => {
  const showUnknownVisitorTooltip = isNamedUnknownVisitor && senderName && channelName;
  if (isLoading) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: showUnknownVisitorTooltip && I18n.text('conversations-inbox-message-history.common-message.sender.unknownNamedVisitorTooltip', {
      integratorName: channelName
    }),
    children: /*#__PURE__*/_jsxs("span", {
      children: [senderName, showUnknownVisitorTooltip && /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        className: "m-left-1"
      })]
    })
  });
};
FriendlySenderName.displayName = 'FriendlySenderName';